export default "__VITE_ASSET__BQdWMII___"